/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Type_UnconfiguredInputs */

const en_api_error_task_type_unconfigured = /** @type {(inputs: Api_Error_Task_Type_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity is no longer configured for this case type. It can only be canceled.`)
};

const pt_br2_api_error_task_type_unconfigured = /** @type {(inputs: Api_Error_Task_Type_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não está mais configurada para este tipo de caso. Ela só pode ser cancelada.`)
};

/**
* | output |
* | --- |
* | "This activity is no longer configured for this case type. It can only be canceled." |
*
* @param {Api_Error_Task_Type_UnconfiguredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_type_unconfigured = /** @type {((inputs?: Api_Error_Task_Type_UnconfiguredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Type_UnconfiguredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_type_unconfigured(inputs)
	return pt_br2_api_error_task_type_unconfigured(inputs)
});